import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from '@/i18n/locales/en/common.json';
import enHome from '@/i18n/locales/en/home.json';
import enProducts from '@/i18n/locales/en/products.json';
import enAuth from '@/i18n/locales/en/auth.json';
import enAdmin from '@/i18n/locales/en/admin.json';
import enGuides from '@/i18n/locales/en/guides.json';
import enPeople from '@/i18n/locales/en/people.json';
import enCourses from '@/i18n/locales/en/courses.json';

import esCommon from '@/i18n/locales/es/common.json';
import esHome from '@/i18n/locales/es/home.json';
import esProducts from '@/i18n/locales/es/products.json';
import esAuth from '@/i18n/locales/es/auth.json';
import esAdmin from '@/i18n/locales/es/admin.json';
import esGuides from '@/i18n/locales/es/guides.json';
import esPeople from '@/i18n/locales/es/people.json';
import esCourses from '@/i18n/locales/es/courses.json';

const resources = {
  en: {
    common: enCommon,
    home: enHome,
    products: enProducts,
    auth: enAuth,
    admin: enAdmin,
    guides: enGuides,
    people: enPeople,
    courses: enCourses,
  },
  es: {
    common: esCommon,
    home: esHome,
    products: esProducts,
    auth: esAuth,
    admin: esAdmin,
    guides: esGuides,
    people: esPeople,
    courses: esCourses,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',

    // Language detection options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'preferred-language',
    },

    // Interpolation options
    interpolation: {
      escapeValue: false, // React already does escaping
    },

    // Namespace configuration
    defaultNS: 'common',
    ns: ['common', 'home', 'tutorials', 'products', 'auth', 'admin', 'guides', 'people', 'courses'],

    // Pluralization
    pluralSeparator: '_',
    contextSeparator: '_',

    // React specific options
    react: {
      useSuspense: false, // Disable suspense to prevent hydration issues
    },
  });

export default i18n;
